<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>Code Creation Requests</h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button label="Request New Code" icon="pi pi-plus" (onClick)="newCodeCreationRequest('new')" />
          }
        </div>
      </div>
    </div>

    <section>
      <p-table [value]="itemMasterRequest()" scrollable="true" dataKey="id" [lazy]="true" (onSort)="onSort($event)">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="createdDate">
              {{ 'CodeCreationComponent.Date' | translateWF: 'Code Request Date' }}
              <p-sortIcon field="createdDate" />
            </th>
            <th>
              {{ 'CodeCreationComponent.ItemMasterDate' | translateWF: 'Item Master Creation Date' }}
            </th>
            <th>
              {{ 'CodeCreationComponent.ItemCode' | translateWF: 'Item Code' }}
            </th>
            <th>
              {{ 'CodeCreationComponent.Company' | translateWF: 'Company' }}
            </th>
            <th>
              {{ 'CodeCreationComponent.InventoryType' | translateWF: 'Inventory Type' }}
            </th>
            <th pSortableColumn="itemDescription">
              {{ 'CodeCreationComponent.Description' | translateWF: 'Description' }}
              <p-sortIcon field="itemDescription" />
            </th>
            <th>
              {{ 'CodeCreationComponent.Manufacturer' | translateWF: 'Manufacturer' }}
            </th>
            <th>
              {{ 'CodeCreationComponent.BaseUnit' | translateWF: 'Base Unit' }}
            </th>
            <th>
              {{ 'CodeCreationComponent.AlternativeUnit' | translateWF: 'Alternative Unit' }}
            </th>
            <th>
              {{ 'CodeCreationComponent.Conversion' | translateWF: 'Conversion' }}
            </th>
            <th>
              {{ 'CodeCreationComponent.PartNumber' | translateWF: 'Part Number' }}
            </th>
            <th>
              {{ 'CodeCreationComponent.MachineType' | translateWF: 'Machine Type' }}
            </th>
            <th>
              {{ 'CodeCreationComponent.Features' | translateWF: 'Features ' }}
            </th>
            <th>
              {{ 'CodeCreationComponent.AdditionalInfo' | translateWF: 'Additional Info' }}
            </th>
            <th>{{ 'CodeCreationComponent.Area' | translateWF: 'Area ' }}</th>
            <th>
              {{ 'CodeCreationComponent.Requester' | translateWF: 'Requester ' }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr class="cursor-pointer hover:bg-green-50" (click)="newCodeCreationRequest(item.id)">
            <td class="min-w-[150px]">
              {{ item.createdDate | date }}
            </td>
            <td class="min-w-[150px]">
              {{ item.itemMasterCreatedDate | date }}
            </td>
            <td class="min-w-[150px]">
              {{ safeUndefinedData(item.itemMasterCode) }}
            </td>
            <td>NT</td>
            <!-- <td>{{ safeUndefinedData(item.company) }}</td> -->
            <td>{{ getInventoryType(item.inventoryTypeReference) }}</td>
            <td>{{ item.itemDescription }}</td>
            <td>{{ safeUndefinedData(item.manufacturer) }}</td>
            <td>{{ getUom(item.mainUom) }}</td>
            <!-- <td>{{ item.conversionRate }}</td> -->
            <td>{{ getUom(item.supportedUoms[0]?.uom) }}</td>
            <td>
              {{ safeUndefinedData(item.supportedUoms[0]?.conversionRate) }}
            </td>
            <td>{{ safeUndefinedData(item.manufacturerPartIdentifier) }}</td>
            <td>{{ getAssetType(item.assetTypeReference) }}</td>
            <td>{{ safeUndefinedData(item.characteristics) }}</td>
            <td>{{ safeUndefinedData(item.extraComments) }}</td>
            <td>{{ getDepartment(item.departmentReference) }}</td>
            <td>{{ safeUndefinedData(item.createdBy) }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="16">
              {{ 'CodeCreationComponent.NotFound' | translateWF: 'No records found' }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      <p-paginator
        [rows]="pageSize()"
        [totalRecords]="totalRecords()"
        [first]="(currentPage() - 1) * pageSize()"
        (onPageChange)="onPageChange($event)"
        [rowsPerPageOptions]="[15, 25, 50]"
        class="mt-4"
      />
    </section>
  </div>
</main>
